import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Long-form muted body copy — keep in sync across RentFactors intro, Next steps leads, How/When, etc. */
export const sectionBodyMutedClass = "text-base text-muted-foreground leading-relaxed"
